import React from 'react';
import { injectIntl, FormattedHTMLMessage } from 'react-intl';

const InjectMassage = props => <FormattedHTMLMessage {...props} />;
export default injectIntl(InjectMassage, {
  withRef: false
});
